module.exports = __webpack_public_path__ + "img/multiple_access_methods.5e95cee0.png";